import React from "react";
import ReactDOM from "react-dom";
// NOTE: React 17 (see frontend/package.json) — ReactDOM.render is the
// correct API here. Do NOT migrate to createRoot without upgrading to
// React 18+ first.
import "./index.css";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import ChatProvider from "./Context/ChatProvider";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <ChakraProvider>
    <BrowserRouter>
      <ChatProvider>
        <App />
      </ChatProvider>
    </BrowserRouter>
  </ChakraProvider>,
  document.getElementById("root")
);
